export const PROPERTY = "propertyId";
export const OWNER = "propertyOwnershipId";
export const DATE_RANGE = "updatedAt";
